import { PricingTier } from '@/pages/unauthenticated/pricing/components/types';

export const TierFeatureTableHeadersSr = ({
  tiers,
}: {
  tiers: PricingTier[];
}) => {
  return (
    <tr className="text-left">
      <th scope="col">
        <span className="sr-only">Feature</span>
      </th>
      {tiers.map((tier) => (
        <th key={tier.activeTier} scope="col">
          <span className="sr-only">{tier.name} tier</span>
        </th>
      ))}
    </tr>
  );
};
